import StringHelper from '../helpers/StringHelper';
import store from '../..'


const SiteEvent = {
    type: `dgb-event`,
    eventPrefix: 'dgb',
    divider: '-',
    action: {
        Click: 'click',
        Load: 'load',
        Error: 'error',
        Success: 'success',
        RouteChange: 'route-change'
    },
    category: {
        Navigation: 'nav',
        Banner: 'banner',
        Deposit: 'deposit',
        Withdrawal: 'withdrawal',
        Notification: 'notification',
        Casino: 'casino'
    },
    /** Triggers custom event
    * @function
    * @param {object} eventData  Custom event name
    */
    dispatch(eventData) {
        const { eventBasedApi } = store.getState().settings;
        if (eventBasedApi) {
            const data = SiteEvent.generateEventData(eventData);
            document.dispatchEvent(new CustomEvent(SiteEvent.type, { detail: data }));
        }
    },
    dispatchEvent(category, type, data) {
        try {
            const eventData = {
                category,
                type,
                data
            }
            SiteEvent.dispatch(eventData);
        } catch (ex) {
            console.log(ex)
        }
    },
    dispatchNavEvent(target, rootTarget, data, type = SiteEvent.action.Click, category = SiteEvent.category.Navigation) {
        try {
            const eventData = {
                target,
                rootTarget,
                category,
                type,
                data
            }
            SiteEvent.dispatch(eventData);
        } catch (ex) {
            console.log(ex)
        }
    },
    dispatchRouteChangeEvent(currentLocation, previousLocation) {
        try {
            const eventData = {
                category: SiteEvent.category.Navigation,
                type: SiteEvent.action.RouteChange,
                data: {
                    currentLocation,
                    previousLocation
                }
            };
            SiteEvent.dispatch(eventData);
        } catch (ex) {
            console.log(ex)
        }
    },
    /** Generates event name
    * @function
    * @param {object} name  Custom event name
    *
    * @returns {object} Generated event deteils
    */
    generateEventData: (eventData) => {
        //eventData.timeStamp = Date.now();
        let name = new Array();
        
        name.push(`${SiteEvent.eventPrefix}${SiteEvent.divider}`);
        //Include category in name if it's specified
        eventData?.category && name.push(`${eventData?.category ? `${StringHelper.camelCaseToKebabCase(eventData?.category)}${SiteEvent.divider}` : ''}`);
        //Include rootTarget in name if it's specified
        eventData?.rootTarget && name.push(`${eventData?.rootTarget ? `${StringHelper.camelCaseToKebabCase(eventData?.rootTarget)}${SiteEvent.divider}` : ''}`);
        //Include target in name if it's specified
        eventData?.target && name.push(`${eventData?.target ? `${StringHelper.camelCaseToKebabCase(eventData?.target?.toLowerCase())}${SiteEvent.divider}` : ''}`);
        //Include type in name if it's specified
        eventData?.type && name.push(`${eventData?.type ? `${eventData?.type}` : ''}`);

        if (name?.length) {
          const lastIndex = name.length - 1;
          const last = name[lastIndex];
        
          if (typeof last === "string" && last.endsWith('-')) {
            name[lastIndex] = last.slice(0, -1);
          }
        }

        return { ...eventData, name: name.join("") };
    }
}
export default SiteEvent